
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import * as React from 'react';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import AlertTitle from '@mui/material/AlertTitle';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useUser } from 'components/hooks/state';
import { I18n, useTranslation } from 'components/hooks/use-translation';
import { PricingCard, PricingCardHeading, PricingCardFeatures } from 'pages/pricing/card';
import ResponsiveContainer from 'components/atomic/organisms/responsive-container';
import MainLayout from 'components/layouts/main-layout';
import Text from 'components/atomic/atoms/text';
import devvSdk from 'utils/devv-sdk';
const Pricing = React.memo(() => {
    const { t }: I18n = useTranslation();
    const { loading } = useUser();
    const [checkoutUrl, setCheckoutUrl] = React.useState<string | null>(null);
    React.useEffect(() => {
        if (!loading) {
            devvSdk
                .createStripeCheckoutSession({
                price_id: process.env.NEXT_PUBLIC_SUPPORTER_PLAN_STRIPE_PRICE_ID as string,
                promo_code_id: process.env.NEXT_PUBLIC_SUPPORTER_PLAN_STRIPE_PROMO_CODE_ID,
                donation: true,
            })
                .then((res) => {
                setCheckoutUrl(res.data.url);
            })
                .catch(() => {
                console.error('Error creating checkout session');
            });
        }
    }, [loading]);
    const handleCheckout = () => {
        if (window && checkoutUrl)
            window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
    };
    return (<MainLayout isFluid headerType="only-logo" title={t('pricing:pageTitle')}>
            <ResponsiveContainer maxWidth="lg">
                <Stack pt={3} spacing={2} textAlign="center" alignItems="center">
                    <Text variant="h2">{t('pricing:pageTitle')}</Text>
                    <Text width={{ md: '50%' }}>{t('pricing:pageSubtitle')}</Text>
                </Stack>

                <Box mt={4}>
                    <Alert variant="outlined" severity="info" icon={<TipsAndUpdatesIcon fontSize="small"/>}>
                        <AlertTitle>{t('pricing:alertTitle')}</AlertTitle>
                        <Text variant="body2">{t('pricing:alertSubtitle')}</Text>
                    </Alert>
                </Box>

                <Grid container spacing={2} mt={4}>
                    <PricingCard>
                        <PricingCardHeading plan="starter"/>
                        <Divider />
                        <PricingCardFeatures plan="starter"/>
                    </PricingCard>

                    <PricingCard>
                        <PricingCardHeading plan="pro" available={false}/>
                        <Divider />
                        <PricingCardFeatures plan="pro" available={false}/>
                    </PricingCard>

                    <PricingCard amazing>
                        <PricingCardHeading plan="supporter" available={!!checkoutUrl} amazing label={false} onClick={handleCheckout}/>
                        <Divider />
                        <PricingCardFeatures plan="supporter"/>
                        <Alert variant="outlined" severity="warning" icon={<WarningRoundedIcon fontSize="small"/>}>
                            Ultimi 32/100 posti rimasti
                        </Alert>
                    </PricingCard>
                </Grid>
            </ResponsiveContainer>
        </MainLayout>);
});
const __Next_Translate__Page__18916ceb1b8__ = Pricing;

    export default __appWithI18n(__Next_Translate__Page__18916ceb1b8__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  